<template>
  <div class="menu-wrapper">
    <template v-for="item in menu">
      <el-menu-item
        v-if="validatenull(item[childrenKey]) && vaildRoles(item) && item.type != 1"
        :index="item[pathKey] + ''"
        @click="open(item)"
        :key="item[labelKey]"
        :class="{'is-active':vaildAvtive(item)}"
      >
        <i :class="item[iconKey]"></i>
        <span slot="title" :alt="item[pathKey]">{{item[labelKey]}}</span>
      </el-menu-item>
      <el-submenu
        v-else-if="!validatenull(item[childrenKey])&&vaildRoles(item)"
        :index="item[pathKey]"
        :key="item[labelKey]"
        :data-test="'' + item.type"
      >
        <template slot="title">
          <i :class="item[iconKey]"></i>
          <span slot="title" :class="{'el-menu--display':collapse && first}">{{item[labelKey]}}</span>
        </template>
        <template v-for="(child,cindex) in item[childrenKey]">
          <el-menu-item
            :index="child[pathKey],cindex"
            @click="open(child)"
            :class="{'is-active':vaildAvtive(child)}"
            v-if="validatenull(child[childrenKey]) && child.type!=1"
            :key="child[labelKey]"
          >
            <i :class="child[iconKey]"></i>
            <span slot="title">
              {{child[labelKey]}}
              {{child[labelKey]=="框架协议盖章"?`(${waitSealCount.frameworkAgreementCount})`:''}}
              {{child[labelKey]=="外付合同盖章"?`(${waitSealCount.outPayContractCount})`:''}}
              {{child[labelKey]=="品牌合同盖章"?`(${waitSealCount.brandContractCount})`:''}}
              {{child[labelKey]=="商务合同附件盖章"?`(${waitSealCount.contractAttachedCount})`:''}}
            </span>
          </el-menu-item>
          <sidebar-item
            v-else
            :menu="[child]"
            :key="cindex"
            :props="props"
            :screen="screen"
            :collapse="collapse"
          ></sidebar-item>
        </template>
      </el-submenu>
    </template>
  </div>
</template>
<script>
  import {mapGetters} from "vuex";
  import validate from "@/util/validate";
  import config from "./config.js";
  import menuService from "@/api/menu";
  export default {
    name: "sidebarItem",
    data() {
      return {
        config: config,
        waitSealCount:''
      };
    },
    props: {
      menu: {
        type: Array
      },
      screen: {
        type: Number
      },
      first: {
        type: Boolean,
        default: false
      },
      props: {
        type: Object,
        default: () => {
          return {};
        }
      },
      collapse: {
        type: Boolean
      }
    },
    created() {
    },
    async mounted() {
      let res = await menuService.getWaitSealCount()
      this.waitSealCount = res.data
      // console.log('=======数量查询=======',res)
    },
    computed: {
      ...mapGetters(["roles"]),
      labelKey() {
        return this.props.label || this.config.propsDefault.label;
      },
      pathKey() {
        return this.props.path || this.config.propsDefault.path;
      },
      iconKey() {
        return this.props.icon || this.config.propsDefault.icon;
      },
      childrenKey() {
        return this.props.children || this.config.propsDefault.children;
      },
      nowTagValue() {
        return this.$router.$avueRouter.getValue(this.$route);
      }
    },
    methods: {
      vaildAvtive(item) {
        const groupFlag = (item["group"] || []).some(ele =>
          this.$route.path.includes(ele)
        );
        let lastIndex = item[this.pathKey].lastIndexOf('/');
        let last = item[this.pathKey].substr(lastIndex + 1, item[this.pathKey].length - 1);
        return this.nowTagValue === item[this.pathKey] || 
               (this.nowTagValue + '/').indexOf(item[this.pathKey] + '/') !== -1 || 
               (this.nowTagValue + '/').indexOf(item[this.pathKey].substr(0, lastIndex) + '/') !== -1 && last == 'index' || 
               groupFlag;
      },
      vaildRoles(item) {
        item.meta = item.meta || {};
        return item.meta.roles ? item.meta.roles.includes(this.roles) : true;
      },
      checkNull(val) {
        return validate.checkNull(val);
      },
      open(item) {
        if (this.screen <= 1) this.$store.commit("SET_COLLAPSE");
        this.$router.$avueRouter.group = item.group;
        this.$router.push({
          path: this.$router.$avueRouter.getPath({
            name: item[this.labelKey],
            src: item[this.pathKey]
          }),
          query: item.query
        });
      }
    }
  };
</script>

